import { useState, useEffect } from 'react';

import TrustpilotReview from './trustpilot_review';
import useTrustpilotReviews from '../../hooks/trustpilot/useTrustpilotReviews';

const trustpilotUrl = '/trustpilot/reviews';

const TrustpilotCompanyReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [page, setPage] = useState(1);
  const [last, setLast] = useState(false);
  const [noReviews, setNoReviews] = useState(false);
  const [loading, setLoading] = useState(true);

  const { response, setUrl, setPage: setPageNum } = useTrustpilotReviews();

  useEffect(() => {
    setUrl(trustpilotUrl);
    setPageNum(page);
  }, []);

  useEffect(() => {
    if (page > 1) {
      setUrl(trustpilotUrl);
      setPageNum(page);
    }
  }, [page]);

  useEffect(() => {
    if (response.result) {
      const { success, data } = response.result;
      if (success) {
        const { reviews: pReviews, lastPage } = data;
        if (!pReviews.length > 0) {
          setNoReviews(true);
          setLoading(false);
          return;
        }

        setReviews(page > 1 ? [...reviews, ...pReviews] : pReviews);
        setLast(lastPage);
        setLoading(false);
      } else {
        setNoReviews(true);
        setLoading(false);
      }
      setUrl(null);
      setPageNum(null);
    }
  }, [response.result]);

  const getNextPage = () => {
    if (!last) {
      setPage(page + 1);
    }
  };

  if (loading) {
    return (
      <div className="fl fl-col ai-c trustpilot-reviews">
        <span className="loading" data-testid="loading">
          <i className="icon-spinner icon-spin icon-large" />
        </span>
      </div>
    );
  }

  if (noReviews) {
    return (
      <div className="fl fl-col ai-c trustpilot-reviews">
        <p>No reviews found. Please refresh the page.</p>
      </div>
    );
  }

  return (
    <div>
      <div className="fl fl-col trustpilot-reviews">
        {reviews &&
          reviews.map(
            ({
              key,
              text,
              title,
              starImage,
              isVerified,
              createdAt,
              displayName,
            }) => (
              <TrustpilotReview
                key={`${createdAt}-${key}`}
                id={key}
                text={text}
                title={title}
                starImage={starImage}
                isVerified={isVerified}
                createdAt={createdAt}
                displayName={displayName}
              />
            ),
          )}
      </div>
      <button type="button" className="load-more-reviews" onClick={getNextPage}>
        {last ? 'End of reviews' : 'Load more reviews'}
      </button>
    </div>
  );
};

export default TrustpilotCompanyReviews;
